/** Component for Load more Functionalities */
export function loadMoreItem(){
    var _THIS = this;
    this.init = function(mainOuterDiv, loadBtn, mainElement){
        $(mainOuterDiv).on('click', loadBtn, function(){
            var curObj =$(this),
            totalPages = parseInt($('[data-all-pages]').val()),
            currentPage = parseInt($('[data-this-page]').val()),
            datacollurl = $('[data-blog-url]').val();
            curObj.attr('disabled', true);
            //curObj.find('[load-more-text]').addClass('hide');
            //curObj.find('[loader]').removeClass('hide');
            var nextUrl = $('[data-next-link]').val();
            var current_page_new = currentPage + 1;
            var next_coll = currentPage + 2;
            var outOf = parseInt($('[data-page-size]').val());
            var totalNo = $('.total').text();
            //alert(current_page_new)
            //return false;
            $.ajax({
            url: nextUrl,
            type: 'GET',
            dataType: 'html',
            success: function(responseHTML){ 
            $('[data-next-link]').val(datacollurl + "?page="+next_coll);
            $('[data-this-page]').val(current_page_new);
            $(mainElement).append($(responseHTML).find(mainElement).html());
            },
            complete: function() {
            if(current_page_new < totalPages) {
            outOf = outOf * current_page_new; 
            $('.outof').text(outOf);
            curObj.attr('disabled', false); curObj.find('[load-more-text]').removeClass('hide'); curObj.find('[loader]').addClass('hide');
            } 
            if(current_page_new >= totalPages) {
            $('.outof').text(totalNo);
            curObj.find('[load-more-text]').removeClass('hide'); curObj.find('[loader]').addClass('hide');
            } 
            }
            })
           });
    }
}

export function loadFilter(items){
    var _THIS = this;
    this.init = function(){
        let liSize =  $('#tag-list ul li').length;    
        $(".more-btn").click(function(){
        $(".expandLi").toggleClass("hide-nav"); 
        if(liSize > items){
        $(".pseduo-track").removeClass("dark_color");  
        } 
        $(".more-btn span").contents().filter(function() {
            return this.nodeType == 3
        }).each(function(){ 
            if($.trim(this.textContent) == 'More'){ 
            this.textContent = this.textContent.replace('More','Less');
            }else if($.trim(this.textContent) == 'Less'){ 
            this.textContent = this.textContent.replace('Less','More');   
            }
        });
        }); 
    }
}